export enum BookerType {
  air = 'air',
  vacations = 'vacations',
  hotelPlusPoints = 'hotel + points',
  bff = 'BFF',
}
